/* @flow */

import Immutable from 'immutable';
import { DatasetConstants } from '../constants/dataset_constants';
import { SharedConstants } from '../constants/shared_constants';

const datasetInitialState = Immutable.Map({
  datasets: Immutable.Map(),
  status: Immutable.Map(),
});

function datasetReducer(state: Immutable.Map = datasetInitialState, action: Object): Immutable.Map {

  switch (action.type) {
    case SharedConstants.SHARED_PURGE:
      return datasetInitialState;

    case DatasetConstants.DATASET_LOAD: {
      state = state.setIn(['datasets', action.ownerId],
        state.getIn(['datasets', action.ownerId], Immutable.Map()));

      state = state.setIn(['status', action.ownerId + "_" + action.datasetId], 'loaded');

      return state.setIn(['datasets', action.ownerId, action.datasetId], Immutable.Map({
        id: action.datasetId,
        ownerId: action.ownerId,
        features: action.features
      }));
    }
    case DatasetConstants.DATASET_SET_STATUS: {
      return state.setIn(['status', action.ownerId + "_" + action.datasetId], action.status);
    }
  }
  return state;
}

export {
  datasetInitialState,
  datasetReducer
};
